import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-base-button',
  templateUrl: './base-button.component.html',
  styleUrls: ['./base-button.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class BaseButtonComponent implements OnInit {
  @Input() label!: string;
  @Input() btnImage!: string;
  @Input() colorClasses!: string;
  @Input() size!: string;
  @Input() type?: string;
  @Input() disabled?: boolean;
  @Output() onClick = new EventEmitter();
  @Input() showDropdownIcon = false;
  @Input() showDarkDropdownIcon = false;

  constructor() {}

  ngOnInit(): void {}

  doClick() {
    if (!this.disabled) this.onClick.emit();
  }
}
